import { ActionIcon, Button, Kbd } from "@mantine/core";
import { spotlight } from "@mantine/spotlight";
import { IconMagnifierOutline18 } from "nucleo-ui-outline-18";
import { useTranslation } from "react-i18next";

import { ICON_SIZE } from "@mountayaapp/theme";

import classes from "../layout/docsHeader.module.css";
import { useModKey } from "./modKey";

/**
 * DocsSearchTrigger is the header's wide command-palette control: a field-shaped
 * button spanning the middle of the action row, carrying the platform's own
 * modifier hint. It is a button rather than an input on purpose, since typing
 * happens inside the palette and a real field here would take focus and hold a
 * second copy of the query. The header hides its cell on narrow viewports, where
 * `DocsSearchIcon` stands in.
 */
export const DocsSearchTrigger = () => {
  const { t } = useTranslation("docs");
  const modKey = useModKey();

  return (
    <Button
      c="dimmed"
      className={classes.searchTrigger}
      fullWidth
      justify="flex-start"
      leftSection={<IconMagnifierOutline18 size={ICON_SIZE.xs} />}
      onClick={spotlight.open}
      rightSection={<Kbd>{modKey} K</Kbd>}
      variant="default"
    >
      {t("search.trigger")}
    </Button>
  );
};

/**
 * DocsSearchIcon is the compact command-palette control the action cluster pins on
 * narrow viewports, where the wide trigger's cell is dropped from the header grid.
 * It opens the same palette, so search stays one press away at every width.
 */
export const DocsSearchIcon = () => {
  const { t } = useTranslation("docs");

  return (
    <ActionIcon aria-label={t("search.trigger")} hiddenFrom="sm" onClick={spotlight.open} size="lg">
      <IconMagnifierOutline18 size={ICON_SIZE.sm} />
    </ActionIcon>
  );
};
